import { render } from "./Header.vue?vue&type=template&id=23c8fbc6&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "@/assets/css/app.a60e7e5f.css?vue&type=style&index=0&id=23c8fbc6&scoped=true&lang=css&external"
import "./Header.vue?vue&type=style&index=1&id=23c8fbc6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23c8fbc6"]])

export default __exports__